<template>
  <div class="mobile-switcher">
    <div class="manage-control" v-if="!isMember()">
      <v-row no-gutters>
        <v-col cols="12" sm="6">
          <mode-switcher v-if="!isMember()"></mode-switcher>
        </v-col>
        <v-col cols="12" sm="6">
          <selected-member v-if="userMode == 'MENTOR'"></selected-member>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ModeSwitcher from "@/containers/navigations/ModeSwitcher"
import SelectedMember from "@/containers/navigations/SelectedMember"
import userMixin from "@/mixins/userMixin"

import { mapGetters } from "vuex"

export default {
  mixins: [userMixin],
  components: {
    ModeSwitcher,
    SelectedMember
  },
  computed: {
    ...mapGetters("globals", { userMode: "getUserMode" })
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.mobile-switcher {
  background-color: $nav-background;
  margin-bottom: 10px;
}
</style>
